export default __webpack_public_path__ + "static/media/mdftr.cfadcb64.png";